module.exports = __webpack_public_path__ + "static/media/bgi-openscout-devstarXD-9.b3b04454.png";